/**
 * Created by Greg on 4/4/2016.
 */


let initialInteract = {
    mouseMode: "edit", showDemands: true,
    linkWidth: 2, demandWidth: 4,
    capVis: {
        showCap: true, minWidth: 4, maxWidth: 20, updateCap: 0
    },
    selectedNodes: [],
    selectedLinks: [],
    coords: {x:0.0, y:0.0}, // Used when adding nodes
    linkInfo: {source: null, target: null, layer: null}  // Used when adding/editing links
};

export default function netVisInteract(state = initialInteract, action) {
    switch (action.type) {
        case 'NODE_LINK_DEL':
            return action.netVisInteract;
        case 'CHANGE_NET':
            return initialInteract;
        case 'LOAD_NET':
            return Object.assign({}, initialInteract, {mouseMode: "view"});
        case 'NEW_NET':
            return Object.assign({}, initialInteract, {mouseMode: "edit"});
        case 'NODE_CLICK':
            return nodeSelect(state, action.node);
        case 'LINK_CLICK':
            return linkSelect(state, action.link);
        case 'BULK_LINK_SELECT':
            return Object.assign({}, state, {selectedLinks: action.selectedLinks});
        case 'PANEL_CLICK':
        case 'PRE_NET_NODE_ADD':
            return netPanelClick(state, action.coords);
        case 'SHOW_DEMAND_CHANGE':
            return showDemandChange(state);
        case 'SHOW_CAP_CHANGE':
            return showCapacityChange(state);
        case 'MODE_CHANGE':
            return modeChange(state, action);
        case 'PRE_NET_LINK_ADD':
            return Object.assign({}, state, {linkInfo: action.linkInfo, selectedNodes: [], selectedLinks: []});
        case 'PRE_LINK_EDIT':
            return Object.assign({}, state, {linkInfo: action.link, selectedNodes: [], selectedLinks: []});
        case 'PRE_NODE_EDIT':
            return Object.assign({}, state, {selectedNodes: [action.node.id], selectedLinks: []});
        case 'NET_LINK_EDIT':
        case 'NET_NODE_EDIT':
            return Object.assign({}, state, {selectedNodes: [], selectedLinks: []});
        default:
            return state;
    }
}

/**
 * Handles raw click events on network nodes, i.e., controls their selection
 * and any further actions depending on editor state.
 * @method nodeSelect
 * @param nodeInfo
 */
function nodeSelect(state, nodeInfo) {
    // console.log("in nodeSelect node: " + nodeInfo.id);
    let nodeId = nodeInfo.id;
    let selectedNodes = state.selectedNodes;
    let stateUpdate = Object.assign({}, state);

    if (selectedNodes.indexOf(nodeId) !== -1) {
        stateUpdate.selectedNodes = selectedNodes.filter(n => n !== nodeId);
    } else {
        stateUpdate.selectedNodes = selectedNodes.concat(nodeId);
    }
    // Check for consistency
    if (state.mouseMode === 'edit' && stateUpdate.selectedNodes.length >= 2) {
        stateUpdate.selectedNodes = [];
    }
    return stateUpdate;
}

function linkSelect(state, linkInfo) {
    // console.log("in linkSelect");
    let linkId = [linkInfo.source, linkInfo.target];
    let selectedLinks = state.selectedLinks;
    let stateUpdate = Object.assign({}, state);
    let link = selectedLinks.find(sl => sl[0] === linkInfo.source && sl[1] === linkInfo.target);
    if (link) {
        stateUpdate.selectedLinks = selectedLinks.filter(sl => sl[0] !== linkInfo.source || sl[1] !== linkInfo.target);
    } else {
        stateUpdate.selectedLinks = selectedLinks.concat([linkId]);
    }
    return stateUpdate;
}

function netPanelClick(state, coords) {
    // console.log("Panel click at x: " + coords.x.toPrecision(4) + " y: " + coords.y.toPrecision(4))
    // Clear any selected nodes or links
    let stateUpdate = Object.assign({}, state);
    stateUpdate.selectedLinks = [];
    stateUpdate.selectedNodes = [];
    stateUpdate.coords = coords;
    return stateUpdate;
}

function showDemandChange(state) {
    // console.log("In Change handler for demands");
    let stateUpdate = Object.assign({}, state);
    stateUpdate.showDemands = !state.showDemands;
    return stateUpdate;
}

function showCapacityChange(state) {
    // console.log("Change handler for capacity");
    let stateUpdate = Object.assign({}, state);
    stateUpdate.capVis.showCap = !state.capVis.showCap
    return stateUpdate;
}

function modeChange(state, action) {
    return Object.assign({}, state, {mouseMode: action.mouseMode,
                                    selectedNodes:[], selectedLinks: []});
}


// WEBPACK FOOTER //
// ./src/reducers/netInteractReducer.js